<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Edit Validity Period </h5>
      <form [formGroup]="EditExpiration" (submit)="SubmitEditExpiration()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Title</label>
            <input formControlName="Title" type="text" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched" class="form-text text-muted MyErrorRedColor">Please enter a field of activity.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Number of Days</label>
            <input formControlName="Day" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Day().valid && get_Form_Day().touched" class="form-text text-muted MyErrorRedColor">Please enter the number of days.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!EditExpiration.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
          <button routerLink="/Expiration" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

